<template>
  <div id="apply-intro-modal">
    <v-layout column align-center>
      <h2 class="modal-grid-header header-1 text-xs-center mt-2 mb-4">
        <span v-if="customHeaderText">{{ customHeaderText }}</span>
        <span v-else>Hi {{ userProfile.first_name }}!</span>
      </h2>
      <p class="text-xs-center mb-4 px-4" v-max-width="260">
        <span v-if="customSubtitleText">
          {{ customSubtitleText }}
        </span>
        <span v-else> Join our Bungalow Community of over 3500 residents nation wide! </span>
      </p>
      <!-- Swiper -->
      <swiper @slideChange="slideChangeHandler" :options="swiperOptions" class="pb-4 mb-4">
        <swiper-slide :key="index" v-for="(item, index) in carouselItems">
          <v-layout column align-center justify-center>
            <blw-illustration type="spot" :name="item.spotIllustration" size="76" />
            <h2 class="lead pb-3 pt-3 text-uppercase">{{ item.title }}</h2>
            <h2 v-if="item.subtitle" class="lead pb-3 text-uppercase">
              {{ item.subtitle }}
            </h2>
          </v-layout>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination" />
        <div
          v-ripple
          slot="button-prev"
          class="swiper-button swiper-button-round swiper-button-prev"
        >
          <v-icon color="charcoal">arrow_back</v-icon>
        </div>
        <div
          v-ripple
          slot="button-next"
          class="swiper-button swiper-button-round swiper-button-next"
        >
          <v-icon color="charcoal">arrow_forward</v-icon>
        </div>
      </swiper>
      <blw-button size="lg" color="charcoal" @click="onContinue" :label="buttonText" />
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ApplyIntroductionModal',
  props: {
    initialSlide: {
      type: Number,
      default: 0,
    },
    customHeaderText: {
      type: String,
    },
    customSubtitleText: {
      type: String,
    },
    buttonText: {
      type: String,
      default: 'Get started',
    },
  },
  data() {
    return {
      swiperOptions: {
        initialSlide: this.initialSlide,
        slidesPerView: 'auto',
        centeredSlides: true,
        simulateTouch: false,
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      carouselItems: [
        {
          spotIllustration: 'success',
          title: 'apply',
          subtitle: '4-5 minutes',
        },
        {
          spotIllustration: 'complete-profile',
          title: 'complete profile',
          subtitle: '2-3 minutes',
        },
        {
          spotIllustration: 'choose-your-home',
          title: 'choose your home',
          subtitle: '2-3 minutes',
        },
        {
          spotIllustration: 'meet-roommates',
          title: 'meet roommates',
          subtitle: '24 hour chat window',
        },
        {
          spotIllustration: 'keys',
          title: 'sign lease',
        },
      ],
    }
  },
  computed: {
    ...mapGetters('user', ['userProfile']),
  },
  methods: {
    slideChangeHandler() {
      this.$trackEvent({
        action: 'Apply Intro Modal Slide Changed',
        properties: {
          location: 'IntroModal',
        },
      })
    },
    onContinue() {
      this.$trackEvent({
        action: 'CTA Clicked: Apply Intro Modal',
        properties: {
          CTA: 'Got It',
          event: 'CTA Clicked',
          location: 'IntroModal',
        },
      })
      this.$root.$emit('closeModal')
    },
  },
  mounted() {
    this.$trackEvent({
      action: 'Apply Intro Modal',
      properties: {
        event: 'open modal',
        CTA: 'Got it',
        location: 'IntroModal',
      },
    })
  },
}
</script>
<style lang="scss">
#apply-intro-modal {
  .swiper-container,
  .swiper-slide {
    width: 100%;
    max-width: 420px;

    @include mobile {
      max-width: 300px;
    }
  }
  .swiper-button {
    display: flex;
    border: 1px solid black;
    @include mobile {
      height: 40px;
      width: 40px;
    }
  }
  .swiper-button-prev {
    left: 0;
  }
  .swiper-button-next {
    right: 0;
  }

  .swiper-pagination-bullet {
    opacity: 1;
    background: white;
    border: 1px solid $charcoal-60;
  }

  .swiper-pagination-bullet-active {
    background: $charcoal-60;
  }
}
</style>
